import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { playerapi } from "../../sharedfiles/EndpointConfig";

export const generalDetailSlice = createSlice({
  name: "generaldetail",
  initialState: {
    playerData: [],
    userCommonPrefrence: {}

  },
  reducers: {
    setPlayerDetail: (state, action) => {
      state.playerData = action.payload;
    },
    setUserCommonPrefrence: (state, action) => {
      state.userCommonPrefrence = action.payload;
    },
    resetUserCommonPrefrence: (state, action) => {
      state.userCommonPrefrence = [];
    },
    resetPlayerDetails: (state, action) => {
      state.playerData = [];
    },

  },
});
export const { setPlayerDetail, setUserCommonPrefrence, resetUserCommonPrefrence, resetPlayerDetails } = generalDetailSlice.actions;

export const getPlayerGeneralDetail = (params) => (dispatch) => {
  if (!params.silent) {
    // Skipped for a background refresh (e.g. a tab revisit) - the caller
    // already has valid data on screen and shouldn't have it blanked out
    // while the refreshed response is in flight. A genuine customer change
    // still clears it first so stale data from the previous customer can't
    // linger during the new request.
    dispatch(resetUserCommonPrefrence())
    dispatch(resetPlayerDetails())
  }
  var url = `${playerapi.getGeneralDetail}` + params.user_id;
  if (params.user_id !== "") {
    apiCaller(url, "GET").then((response) => {
      if (response.data !== null && response.data !== undefined) {
        if (response.status == 200) {
          dispatch(setPlayerDetail(response.data))
          dispatch(setUserCommonPrefrence(response.data.userCommPreference))
        }
      }
    }).catch(() => { });
  }
};

export default generalDetailSlice.reducer;
